import { AxiosHelper } from '@/modules/shared/infra/protocols/http';
import config from '@/Constants';
import { SyncState } from '../interfaces/ISync';

async function pullSyncState(syncStateId: string): Promise<SyncState> {
  const response = await AxiosHelper.get({
    url: `${config.ITEM_SYNC_STATES_URL}/${syncStateId}`,
  });
  if (response.statusCode < 200 || response.statusCode >= 300) {
    throw new Error();
  }
  return response.body;
}

export { pullSyncState };
